import React from "react";
import {InlineEditor} from "./InlineEditor";
import "./Persona.css"
import {MultiLineTextEditor} from "../common/MultilineTextEditor";
import {range} from "../../utils/functions";
import {IsEditFlags} from "../../utils/IsEditFlags";
import {PersonaImagerKey2Src, PersonaImages} from "../../assets/PersonaImage";
import {CjmapPersona} from "../../models/CjmapPersona";
import {DraggableCore, DraggableEventHandler} from "react-draggable";

export const INITIAL_PERSONA_WIDTH = 300;
export const MIN_PERSONA_WIDTH = 200;

type PersonaProps = {
    persona: CjmapPersona;
    showSize: number;
    readOnly: boolean;
    onChangeTagLine(tagline: string): void;
    onChangeImageKey(image_key: string): void;
    onChangeSpecsName(index: number, name: string): void;
    onChangeSpecsValue(index: number, value: string): void;
    onChangeDescription(description: string): void;

    onResize(persona_width: number): void;
}

export const Persona = (props: PersonaProps) => {

    const show_persona = 0 < props.showSize;
    const persona_style = {
        width: props.showSize
    };

    const [show_persona_image_selector, showPersonaImageSelector] = React.useState(false);

    const [is_edit_flags, setRawIsEditFlags] = React.useState(
        IsEditFlags.createFromNames(
            ['tagline', ...range(0, 6).map(i => [`specs_key${i}`, `specs_value${i}`]).flat(), 'description']
        )
    );
    const setIsEditFlags = (flags: IsEditFlags) => {
        !props.readOnly && setRawIsEditFlags(flags);
    }

    const handleDragSplitter: DraggableEventHandler = (e, data) => {
        props.onResize(Math.max(MIN_PERSONA_WIDTH, props.showSize + data.deltaX));
    };

    return (
        <div className="cjmap-persona" style={persona_style}>
            {show_persona && <>

                {show_persona_image_selector &&
                  <div className="persona-image-selector">
                      {PersonaImages.map(images =>
                          <img key={images.key}
                               src={images.src}
                               onClick={() => {
                                   props.onChangeImageKey(images.key);
                                   showPersonaImageSelector(false);
                               }}
                          />
                      )}
                  </div>
                }

              <div className="persona-images">
                <div onClick={() => !props.readOnly && showPersonaImageSelector(true)}>
                  <img src={PersonaImagerKey2Src(props.persona.ImageKey)}/>
                </div>
                <MultiLineTextEditor
                  value={props.persona.Tagline} isEdit={is_edit_flags.isEdit('tagline')}
                  onEditEnd={(value, is_cancel) => {
                      if (is_cancel) {
                          setIsEditFlags(is_edit_flags.clearAllEdit());
                      } else {
                          props.onChangeTagLine(value);
                          setIsEditFlags(is_edit_flags.editNext());
                      }
                  }}
                  onClick={() => setIsEditFlags(is_edit_flags.edit('tagline'))}
                />

              </div>
              <dl className="persona-specs">
                  {props.persona.Specs.toArray().map(spec =>
                      <>
                          <dt onClick={() => setIsEditFlags(is_edit_flags.edit(`specs_key${spec.index}`))}>
                              <InlineEditor value={spec.name}
                                            isEdit={is_edit_flags.isEdit(`specs_key${spec.index}`)}
                                            onChangeValue={text => props.onChangeSpecsName(spec.index, text)}
                                            onCancel={() => setIsEditFlags(is_edit_flags.clearAllEdit())}
                                            onDecide={() => setIsEditFlags(is_edit_flags.editNext())}
                                            onMoveNext={() => setIsEditFlags(is_edit_flags.editNext())}
                                            onMovePrev={() => setIsEditFlags(is_edit_flags.editPrev())}
                              />
                          </dt>
                          <dd onClick={() => setIsEditFlags(is_edit_flags.edit(`specs_value${spec.index}`))}>
                              <InlineEditor value={spec.value}
                                            isEdit={is_edit_flags.isEdit(`specs_value${spec.index}`)}
                                            onChangeValue={text => props.onChangeSpecsValue(spec.index, text)}
                                            onCancel={() => setIsEditFlags(is_edit_flags.clearAllEdit())}
                                            onDecide={() => setIsEditFlags(is_edit_flags.editNext())}
                                            onMoveNext={() => setIsEditFlags(is_edit_flags.editNext())}
                                            onMovePrev={() => setIsEditFlags(is_edit_flags.editPrev())}
                              />
                          </dd>
                      </>
                  )}
              </dl>
              <div className="persona-description">
                <MultiLineTextEditor
                  value={props.persona.Description} isEdit={is_edit_flags.isEdit('description')}
                  onEditEnd={(value, is_cancel) => {
                      !is_cancel && props.onChangeDescription(value);
                      setIsEditFlags(is_edit_flags.clearAllEdit());
                  }}
                  onClick={() => setIsEditFlags(is_edit_flags.edit('description'))}
                />
              </div>

              <DraggableCore onDrag={handleDragSplitter}>
                <div className="persona-splitter" onClick={e => e.stopPropagation()}/>
              </DraggableCore>
            </>
            }
        </div>
    );
}
